module.exports = __webpack_public_path__ + "static/media/kayleenOlson.e76b8089.jpg";